import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react'

export type SortState<F extends string> = { by: F; dir: 'asc' | 'desc' }

/**
 * Cabecera de tabla ordenable: clic ordena por la columna, el siguiente clic
 * invierte el sentido. La columna activa pinta la flecha del sentido; las
 * inactivas un indicador tenue de "ordenable".
 */
export default function SortableTh<F extends string>({
  label,
  field,
  sort,
  onSort,
  align = 'left',
}: {
  label: string
  field: F
  sort: SortState<F> | null
  onSort: (field: F) => void
  align?: 'left' | 'right'
}) {
  const active = sort?.by === field
  const Icon = active ? (sort!.dir === 'asc' ? ArrowUp : ArrowDown) : ChevronsUpDown
  return (
    <th className={`px-4 py-3 font-medium ${align === 'right' ? 'text-right' : ''}`}>
      <button
        type="button"
        onClick={() => onSort(field)}
        className={`inline-flex items-center gap-1 uppercase tracking-wider transition-colors hover:text-jr2-700 dark:hover:text-jr2-200 ${
          active ? 't-primary' : ''
        }`}
      >
        {label}
        <Icon size={12} className={active ? '' : 'opacity-40'} />
      </button>
    </th>
  )
}
